import React, { useState } from 'react'
import Button from '../../../utils/components/Button/Button'
import Input from '../../../utils/components/Input/Input'
import Options from '../../../utils/components/Options/Options'
import style from "./ListStikers.module.css"
const ListStickers = ({ stickers, formik, isEdit, setIsEdit }) => {
  const [imgSrc, setImgSrc] = useState(null)
  return (
    <div className={style.container}>
      <div className={style.form}>
        <label className={style.file}>
          {
            imgSrc && <img src={imgSrc} />
          }
          <input type="file" accept="image" onChange={e => {


            if (e.target.files[0] && e.target.files[0].type.includes('image')) {
              setImgSrc(URL.createObjectURL(e.target.files[0]))
              formik.setFieldValue("image", e.target.files[0])
            }
          }} />

        </label>
        <Input placeholder='Nombre' name="name" value={formik.values.name} onChange={formik.handleChange} />
        <Button type='submit' onClick={formik.handleSubmit} text={isEdit ? "Editar" : "Guardar"} />
      </div>
      <div className={style.grid}>
        {stickers.map(stiker => (
          <div className='content-card-list fit-content-heigth'>
            <Options options={[
              {
                onClick: (e) => {
                 
                  if (stiker?.image?.url?.origin) {
                    setImgSrc(stiker.image.url.origin)
                    formik.setFieldValue("image", stiker.image.url.origin)
                  } else {
                    setImgSrc(null)
                    formik.setFieldValue("image", null)
                  }

                  formik.setFieldValue("name", stiker.name)


                  setIsEdit(true)
                },
                text: "Editar"
              }
            ]} />
            {stiker?.image?.url?.origin && <img src={stiker.image && stiker.image.url && stiker.image.url.origin} />}
            <div className='row centerItems'>
              <div>{stiker.name}</div>
              <div>{stiker.description}</div>
              <div>{stiker.requiredScore}</div>
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}

export default ListStickers